// extracted by mini-css-extract-plugin
export default {"disclaimer":"LegalBannerDisclaimer__disclaimer--NabGt"};